import { FC, ReactNode } from 'react';
import ContentArea from '../../ContentArea';
import { SamlingssidaResponse } from '../../types/pages';
import { ContentResponse } from '../../types/shared';
import styles from './Samlingssida.module.css';

interface ISamlingssidaProps {
  contentResponse: ContentResponse;
}

const Samlingssida: FC<ISamlingssidaProps> = ({ contentResponse }): ReactNode => {
  const samlingssidaResponse = contentResponse.content as SamlingssidaResponse;

  const toppytanStyling = `${styles.toppytan}`;
  const huvudinnehållStyling = `${styles.huvudinnehåll}`;

  return (
    <>
      <div className={toppytanStyling}>
        {samlingssidaResponse.toppytan && <ContentArea contentAreaResponse={samlingssidaResponse.toppytan} />}
      </div>
      <div className={huvudinnehållStyling}>
        {samlingssidaResponse.huvudinnehåll && <ContentArea contentAreaResponse={samlingssidaResponse.huvudinnehåll} />}
      </div>
    </>
  );
};

export default Samlingssida;
